import { useState } from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, MessageBar, MessageBarType } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../components/ModalProvider';

interface UsePublishDialogProps {
    onPublish: () => Promise<void>;
}

export function usePublishDialog({ onPublish }: UsePublishDialogProps) {
    const { t } = useTranslation();
    const { pushError } = useModalContext() as any;
    const [isOpen, setIsOpen] = useState(false);

    const openPublishDialog = () => {
        setIsOpen(true);
    };

    const closePublishDialog = () => {
        setIsOpen(false);
    };

    const PublishDialog = () => (
        <Dialog
            hidden={!isOpen}
            onDismiss={closePublishDialog}
            maxWidth={600}
            minWidth={600}
            dialogContentProps={{
                type: DialogType.normal,
                title: t('settingsPanel.agentPanel.publishServer'),
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            <MessageBar className='marginTopL'
                messageBarType={MessageBarType.warning}>
                Veröffentlichen eines REAL GAIN/MCP-Servers ermöglicht es anderen Nutzern, unmittelbar auf ihn zuzugreifen.
            </MessageBar>
            <DialogFooter className="marginTopL">
                <PrimaryButton 
                    text={'Veröffentlichen'} 
                    onClick={async () => {
                        try {
                            await onPublish();
                            closePublishDialog();
                        } catch (error) {
                            pushError(error);
                        }
                    }} 
                />
                <DefaultButton 
                    onClick={closePublishDialog} 
                    text={t('global.cancel')} 
                />
            </DialogFooter>
        </Dialog>
    );

    return {
        PublishDialog,
        openPublishDialog,
        closePublishDialog
    };
} 